import createAsyncAction from 'shared/utils/createAsyncAction';
import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';
import { getCurrentLanguage } from 'modules/language/selectors/language';

import createAction from './index';
import * as services from '../services/otpVerification';

export const RESEND_OTP_CODE = createAsyncAction(createAction('RESEND_OTP_CODE'));

export const sendIdentityInfo = () => (dispatch, getState) => {
  dispatch({ type: RESEND_OTP_CODE.pending });

  const state = getState();

  const { policyId, email, phoneNumber, verificationToken, secondaryLoginData } = state.auth.userInfo;
  const { selectedOrganizationToken } = state.auth.organizations;
  const locale = getCurrentLanguage();
  const userData = policyId
    ? { externalId: policyId, phoneNumber, email }
    : secondaryLoginData;

  const apiCallParams = {
    mutation: services.RESEND_OTP,
    variables: {
      ...userData,
      orgId: selectedOrganizationToken,
      token: verificationToken,
      locale,
    },
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(() => dispatch({ type: RESEND_OTP_CODE.success }))
    .catch((err) => {
      dispatch(errorAction(RESEND_OTP_CODE.failure, err));
      throw err;
    });
};
